import InvertedColorsContext from '@contexts/invertedColors'
import { useContext } from 'react'

const useHasInvertedColors = (): boolean => !!useContext(InvertedColorsContext)

export default useHasInvertedColors
